import React, { useContext, useState } from 'react';
import { Button, Divider, Form, Image, Input, message, Upload } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import { MCPResearchContext } from '../MCPResearchUI';
import { DefaultLogoImg } from '../../ResearchUI/ResearchUIConstants';
import { uri1 } from '../../../api/index';
import { getToken } from '../../../common/auth';
import { formKeys } from '../MCPServerConstants';
const Logo = () => {
    const UploadTypes = {
        logo: 'logo',
        favIcon: 'favIcon',
    };

    const { form, mcpAppDetails } = useContext(MCPResearchContext);

    const [logoLink, setLogoLink] = useState(mcpAppDetails.basicDetails?.MCPServerLogo?.mcp_server_logo_url ?? '');
    const [favIconLink, setFavIconLink] = useState(mcpAppDetails.basicDetails?.MCPServerLogo?.fav_icon_logo_url ?? '');

    const onChangeLogoLink = (logoUrl, uploadType) => {
        if (uploadType === UploadTypes.logo) {
            setLogoLink(logoUrl);
            // setLogoDetail({ ...logoDetail, logoUrl: logoUrl });
        } else if (uploadType === UploadTypes.favIcon) {
            setFavIconLink(logoUrl);
            // setLogoDetail({ ...logoDetail, favIconUrl: logoUrl });
        }
    };

    const onUploadLogo = (info, uploadType) => {
        if (info.file.status === 'done') {
            if (info?.file?.response?.success) {
                const logoUrl = info?.file?.response?.data?.url;
                if (uploadType === UploadTypes.logo) {
                    onChangeLogoLink(logoUrl, UploadTypes.logo);
                    form.setFieldValue([formKeys.logo, 'mcp_server_logo_url'], logoUrl);
                } else if (uploadType === UploadTypes.favIcon) {
                    onChangeLogoLink(logoUrl, UploadTypes.favIcon);
                    form.setFieldValue([formKeys.logo, 'fav_icon_logo_url'], logoUrl);
                }
            } else {
                message.error('Something Went Wrong');
            }
        }
        if (info.file.status === 'error') {
            message.error('Error in uploading');
        }
    };

    return (
        <div className='container'>
            <div className='ns-flex ns-flex_gap ns-flex_space-between'>
                <div className='ns-flex ns-flex_vertical ns-flex_centered ns-flex_gap ns-card-border-radius ns-border-small ns-width-full flex-1'>
                    <Divider orientation='left'>DB Logo</Divider>
                    <Image
                        className='ns-width-full'
                        preview={false}
                        src={`data:image/jpeg;base64,${mcpAppDetails.basicDetails?.MCPServerLogo?.mcp_server_logo}`}
                        fallback={DefaultLogoImg}
                    />
                    <Image
                        preview={false}
                        width={35}
                        src={`data:image/jpeg;base64,${mcpAppDetails.basicDetails?.MCPServerLogo?.fav_icon_logo}`}
                        fallback={DefaultLogoImg}
                    />
                </div>
                <div className='ns-flex ns-flex_vertical ns-flex_centered ns-flex_gap ns-card-border-radius ns-border-small ns-width-full flex-1'>
                    <Divider orientation='left'>Logo</Divider>
                    <Image src={logoLink ?? 'error'} fallback={DefaultLogoImg} />
                    <Image width={35} src={favIconLink ?? 'error'} fallback={DefaultLogoImg} />
                </div>
                <div className='ns-width-full flex-2'>
                    <div className='ns-flex ns-padding-small'>
                        <Form.Item name={[formKeys.logo, 'mcp_server_logo_url']} noStyle>
                            <Input
                                width={'100%'}
                                addonBefore='Logo'
                                placeholder='Place Logo Link'
                                // value={logoLink}
                                onChange={(e) => onChangeLogoLink(e.target.value, UploadTypes.logo)}
                            />
                        </Form.Item>
                        <Upload
                            action={uri1 + 'mcp/uploadlogo'}
                            name='logo'
                            headers={{ Authorization: `Bearer ${getToken()}` }}
                            onChange={(info) => onUploadLogo(info, UploadTypes.logo)}
                            showUploadList={false}
                            accept='image/*'
                        >
                            <Button icon={<CloudUploadOutlined />}></Button>
                        </Upload>
                    </div>
                    <div className='ns-flex ns-padding-small'>
                        <Form.Item name={[formKeys.logo, 'fav_icon_logo_url']} noStyle>
                            <Input
                                addonBefore='Fav Icon'
                                placeholder='Place Fav Icon Link'
                                // value={favIconLink}
                                onChange={(e) => onChangeLogoLink(e.target.value, UploadTypes.favIcon)}
                            />
                        </Form.Item>
                        <Upload
                            action={uri1 + 'mcp/uploadlogo'}
                            name='logo'
                            headers={{ Authorization: `Bearer ${getToken()}` }}
                            onChange={(info) => onUploadLogo(info, UploadTypes.favIcon)}
                            showUploadList={false}
                            accept='image/*'
                        >
                            <Button icon={<CloudUploadOutlined />}></Button>
                        </Upload>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Logo;
